module.exports = __webpack_public_path__ + "static/media/ic_visa.99fb24b4.png";